<script>
    //import Menu from "../../components/Menu.svelte";
    import { getRole, getUserId } from "../../js/localInfo";
    import { post } from "../../js/labit-connection";

    import TextEdit from "../../components/TextEdit.svelte";
    import Combobox from "../../components/Combobox.svelte";

    // import MenuMyProfile from "../../components/MenuMyProfile.svelte";
    import TaskItem from "../../components/TaskItem.svelte";

    import { onMount } from "svelte";
    import { getDateSring, longMsToTime, msToTime, countNonWorkingDays } from "../../js/formatDateTime";
    import DialogSpanCalendarPickerEvent from "../calendar/screens/components/DialogSpanCalendarPickerEvent.svelte";
    import Popup from "../../components/Popup.svelte";

    const PAGE = "FACTORIAL";

    let myRole = getRole();
    let myId = getUserId();
    //let myId = 26;

    let showPopup = false;
    let requestAbsenceType = "days";
    let half = 0;
    
    let projectsAndPhases = [],
        projects = [],
        taskTypesBBDD = [],
        taskTypes = [],
        tasks = [],
        absenceTypes = [],
        pendingAbsences = [],
        acceptedAbsences = [],
        deniedAbsences = [];

    let selectedProject = { label: "", value: "" },
        selectedPhase = { label: "", value: "" },
        selectedTaskType = { label: "", value: "" },
        selectedAbsenceType = { label: "", value: "" };
    
    let taskDescription = "",
        taskStart = "",
        taskEnd = "",
        absenceDescription = "",
        preSelectedProject = "", // TODO: Valores preseleccionados
        preSelectedPhase = "",
        preSelectedTaskType = "",
        chartType = "week"
        ;

    let total_time = 23,
        used_time = 0,
        available_time = 0,
        requested_time = 0,
        accepted_time = 0;

    let projectObj = {},
        phaseObj = {},
        taskTypeObj = {};

    var chart;
    let today = getDateSring();
    
    let absenceStart = moment().format("DD/MM/YYYY");
    let absenceEnd = moment().format("DD/MM/YYYY");
    let absenceHourStart = "",
        absenceHourEnd = "";

    const clickedPopup = () => {
        showPopup = false;
    }

    const getGeneratedDaysUntilToday = (date) => {
        const freeTimeConstant = 23 / 12;
        const days = moment().diff(moment(date, 'DD-MM-YYYY'), 'days');
        const monthDaysConstant = moment().isLeapYear() ? 366 / 12 : 365 / 12;
        const freeDays = days / monthDaysConstant * freeTimeConstant;
        return freeDays.toFixed();
    }

    const getAbsenceTypes = async () => {
        const absences = await post(
            `select id, name from absence_type;`
        );

        absences.forEach((e) => {
            absenceTypes = [...absenceTypes, { label: e.name, value: e.id}];
        });
    }

    const getAbsences = async () => {
        let year = new Date();
        let yearDate = new Date( (year.getFullYear()).toString() );

        let query = `select a.id, a.start, a.end, a.accepted_by_team_leader, a.accepted_by_ceo, t.name, t.approvable from absences as a inner join absence_type as t on a.absence_type_id = t.id where a.user_id = ${myId} and a.start > ${yearDate.getTime()};`;
        //console.log(query);
        let absences = await post(
            query
        );

        deniedAbsences = [];
        pendingAbsences = [];
        acceptedAbsences = [];

        // TODO: Calcular tiempo generado
        // Insertar en BBDD el día de inicio de cada trabajador en la empresa (exportar de factorial supongo)
        // available_time = getGeneratedDaysUntilToday(diaQueSea);
        available_time = 11040; // 23 días == 184 horas == 11040' (de 8h laborales)
        used_time = 0;
        requested_time = 0;
        accepted_time = 0;
        
        const hollydays = await getHollydays();

        absences.forEach((e) => {
            const start = moment(e.start, "x");
            const end = moment(e.end, "x");
            const end2 = moment(end);
            const startString = start.format("DD/MM/YYYY");
            const endString = end2.subtract(1,'ms').format("DD/MM/YYYY");
            
            if(e.accepted_by_ceo === "-1") {
                deniedAbsences = [...deniedAbsences, { id: e.id, type: e.name, start: startString, end: endString}];
            } else if(e.accepted_by_ceo === "0") {
                pendingAbsences = [...pendingAbsences, { id: e.id, type: e.name, start: startString, end: endString}];
            } else if(e.accepted_by_ceo === "1") {
                acceptedAbsences = [...acceptedAbsences, { id: e.id, type: e.name, start: startString, end: endString}];
            }

            if(e.approvable === "1") {
                //const diff = ((Math.abs(end.diff(start,'minutes')) / 60 ) / 24 ) * 8; // paso de minutos a días LABORALES (1 dia laboral == 8h)
                let diff = Math.abs(end.diff(start,'minutes')); // PUESTO EN MINUTOS POR SI SE PIDE MEDIO DIA
                
                if (diff >= 1440) {
                    let nonWorking = countNonWorkingDays(start, end2, hollydays); // Getting days
                    nonWorking = nonWorking * 8 * 60; // days to minutes
                    diff = (Math.round((diff / 60) / 24) * 8) * 60; // Converts days of 24h to days of 8h
                    diff = diff - nonWorking;
                }
                
                if (e.accepted_by_ceo === "1") {
                    available_time -= diff;
                    if(!moment().isBefore(start)) { 
                        used_time += diff;
                    } else {
                        accepted_time += diff;
                    }
                } else if (e.accepted_by_ceo === "0") {
                    requested_time += diff;
                }
            }
        });
    }
    
    const getHollydays = async () => {
        let res = await post(
            `SELECT g.name, g.date 
                FROM people AS p
                INNER JOIN companies AS c ON p.company_id = c.company_id
                INNER JOIN general_holidays AS g ON c.City = g.location
                WHERE p.contact_id = ${myId};`
        );
        const now = moment();
        return res.map((e) => {
            return {name: e.name, date: moment(e.date, "YYYY-MM-DD")};
        }).filter((e) => e.date.isSameOrAfter(now, 'day') );
    }

    const requestAbsence = async (start, end, type, desc, half = 0, hourStart = "", hourEnd = "") => {

        let startDate = moment(start, "DD/MM/YYYY");
        let endDate;

        switch (half) {
            case 0:
                if(hourStart !== "" && hourEnd !== "") {
                    const hourStartParts = hourStart.split(":");
                    startDate.hour(parseInt(hourStartParts[0]));
                    startDate.minute(parseInt(hourStartParts[1]));

                    endDate = moment(`${start} ${hourEnd}`, "DD/MM/YYYY HH:mm");
                } else if (end !== "") {
                    endDate = moment(end, "DD/MM/YYYY");
                    endDate.endOf("day");
                    endDate.add(1, 'ms');
                } else {
                    endDate = moment(start, "DD/MM/YYYY");
                    endDate.endOf("day");
                    endDate.add(1, 'ms');
                }
                break;
            case 1:
                startDate.hour(9);
                endDate = moment(start, "DD/MM/YYYY"); // Creo otro objeto moment() para que sean independientes start y end, si no, end y start cambian a la vez
                endDate = endDate.hour(13);
                break;
            case 2:
                startDate.hour(14);
                endDate = moment(start, "DD/MM/YYYY");
                endDate = endDate.hour(18);
                break;
        }

        if(type !== "" && desc !== "" && !endDate.isBefore(startDate)) {
            
            await post(
                `INSERT INTO absences (description, start, end, accepted_by_team_leader, accepted_by_ceo, half, requested_time, user_id, absence_type_id) VALUES ('${desc}','${startDate.format("x")}', '${endDate.format("x")}', '0', '0', '${half}', '${moment().valueOf()}', '${myId}', '${type.value}');`
            );

            await getAbsences();

            selectedAbsenceType = { label: "", value: ""};
            absenceDescription = "";

        } else {
            showPopup = true;
        }
    }

    const changeDay = (day1, day2) => {
        let hourPosition = day1.findIndex((e) => {
            return e.includes(":");
        });
        let hour = day1[hourPosition].split(":");
        day1.splice(hourPosition, 1);

        if (day1[0] === "ayer" || day1[0] === "yesterday") {
            day2.setDate(day2.getDate() - 1);
        } else if (day1[0].includes("-")) {
            let day = day1[0].split("-");
            day2.setFullYear(day[2], day[1] - 1, day[0]);
        } else if (day1[0].includes("/")) {
            let day = day1[0].split("/");
            day2.setFullYear(day[2], day[1] - 1, day[0]);
        } else {
            day2.setDate(day1[0]);
        }

        day2.setHours(hour[0], hour[1], 0);
        return day2;
    }
    
    const getProjectsAndPhases = async () => {
        projectsAndPhases = await post(
            `SELECT proj.project_id as "project_id", CONCAT(proj.FolderLabitCode, " - ", proj.name) as "project", ph.id as "phase_id", ph.name as "phase"
            FROM people as p
                INNER JOIN projectPeople as pp ON p.contact_id = pp.people
                INNER JOIN projects as proj ON pp.project = proj.project_id
                INNER JOIN phase as ph ON ph.project = proj.project_id
            where p.contact_id = ${myId}
            ORDER BY Project desc;`
        );

        let project_id_1 = "-1",
            project_name_1 = "";
        projectsAndPhases.forEach((e) => {
            let project_id_2 = e.project_id,
                proj_name_2 = e.project;

            if (project_id_1 !== project_id_2 && project_id_1 !== "-1") {
                projects = [
                    ...projects,
                    { label: project_name_1, value: project_id_1 },
                ];

                project_name_1 = proj_name_2;
            }

            project_id_1 = project_id_2;
            project_name_1 = proj_name_2;
        });

        projects = [
            ...projects,
            { label: project_name_1, value: project_id_1 },
        ];

        projectObj = projectsAndPhases.reduce((a,v) => ({...a, [v.phase_id]: v.project}), {});
        phaseObj = projectsAndPhases.reduce((a,v) => ({...a, [v.phase_id]: v.phase}), {});
    }

    const modifyTask = async (event) => {
        let id = event.detail.id;
        let desc = event.detail.desc;
        let start = event.detail.start;
        let end = event.detail.end;

        let query = `update tasks set description = '${desc}', start = ${start}, end = ${end} where id = ${id};`
        await post(query);

        await getTasks();
    }

    const copyTask = async (event) => {

        // Obtener última tarea del día de hoy para el usuario con ID. Si hay, utilizar hora de fin para hora inicio de esta tarea

        let id = event.detail.id;
        const now = moment().format("x");
        const query = `insert into tasks (description, start, end, task_type_id, phase_id, user_id) select description, "${now}", (end-start)+${now}, task_type_id, phase_id, user_id from tasks where id = ${id};`;
        
        await post(
            query
        );
        await getTasks();
    }

    const deleteTask = async (event) => {
        let id = event.detail.id;
        await post(
            `delete from tasks where id = ${id};`
        );
        await getTasks();
    }

    const addTask = async (desc, phaseId, taskTypeId, start, end) => {
        
        // SI el tipo de 'addTask' es 'timeoff', 
        
        if (desc !== "" && phaseId !== "" && taskTypeId !== "" && start !== "" && end !== "") {
            let formattedDayStart = new Date();
            let formattedDayEnd = new Date();

            if(start.includes(" ")) {
                let startParts = start.split(" ");
                formattedDayStart = changeDay(startParts, formattedDayStart);
            } else {
                start = start.split(":");
                formattedDayStart.setHours(start[0], start[1], 0);
            }

            let endParts = end.split(" ");
            if (endParts.length > 1) {
                formattedDayEnd = changeDay(endParts, formattedDayEnd);
            } else {
                end = end.split(":");
                formattedDayEnd.setHours(end[0], end[1], 0);
            }

            if((formattedDayStart<formattedDayEnd) && (formattedDayEnd - formattedDayStart) < 36000000) { // 10 horas
                let query = `INSERT INTO tasks (description, start, end, phase_id, task_type_id, user_id) VALUES ('${desc}',${formattedDayStart.getTime()},${formattedDayEnd.getTime()}, '${phaseId}', '${taskTypeId}', '${myId}');`;

                await post(
                    query
                );
                await getTasks();

                taskDescription = "";
                taskStart = "";
                taskEnd = "";

            } else {
                showPopup = true;
            }

        } else {
            showPopup = true;
        }
    };


    
    const getTaskTypes = async () => {
        taskTypesBBDD = await post(
            `Select * from task_type;`
        );
        
        taskTypeObj = taskTypesBBDD.reduce((a,v) => ({...a, [v.id]: v.name}), {});
    }

    const getColor = () => {
        const colors = [
            "rgba(56, 134, 89, 0.65)", "rgba(63, 143, 91, 0.65)", "rgba(69, 152, 92, 0.65)", "rgba(82, 170, 94, 0.65)", 
            "rgba(82, 170, 138, 0.65)", "rgba(58, 174, 216, 0.65)", "rgba(51, 196, 235, 0.65)", "rgba(43, 217, 254, 0.65)", 
            "rgba(149, 113, 134, 0.65)", "rgba(217, 184, 196, 0.65)", "rgba(112, 61, 87, 0.65)", "rgba(64, 42, 44, 0.65)", 
            "rgba(36, 23, 21, 0.65)", "rgba(119, 152, 171, 0.65)", "rgba(195, 219, 197, 0.65)", "rgba(163, 217, 255, 0.65)", 
            "rgba(152, 114, 132, 0.65)", "rgba(157, 191, 158, 0.65)", "rgba(208, 214, 181, 0.65)", "rgba(249, 181, 172, 0.65)", 
            "rgba(238, 118, 116, 0.65)", "rgba(78, 2, 80, 0.65)", "rgba(16, 73, 17, 0.65)", "rgba(8, 7, 8, 0.65)", 
            "rgba(255, 184, 209, 0.65)", "rgba(228, 180, 194, 0.65)", "rgba(231, 206, 227, 0.65)", "rgba(224, 225, 233, 0.65)", 
            "rgba(221, 253, 254, 0.65)", "rgba(35, 87, 137, 0.65)", "rgba(193, 41, 46, 0.65)", "rgba(241, 211, 2, 0.65)", 
            "rgba(207, 232, 239, 0.65)", "rgba(198, 219, 240, 0.65)", "rgba(174, 209, 230, 0.65)", "rgba(160, 196, 226, 0.65)", 
            "rgba(133, 199, 222, 0.65)", "rgba(94, 93, 92, 0.65)", "rgba(69, 54, 67, 0.65)", "rgba(40, 17, 43, 0.65)", 
            "rgba(46, 14, 2, 0.65)", "rgba(88, 25, 8, 0.65)", "rgba(152, 54, 40, 0.65)", "rgba(226, 174, 221, 0.65)", 
            "rgba(235, 203, 244, 0.65)", "rgba(113, 128, 172, 0.65)", "rgba(43, 69, 112, 0.65)", "rgba(168, 208, 219, 0.65)"
        ];

        return colors[Math.floor(Math.random() * 48)];
    };

    const getTasksToReport = async(period = "week") => {

        let startMillis = "";
        let endMillis = "";
        let labels = [];
        
        if (period === "week") {
            //console.log("week");
            labels = ["Mon, ", "Tue, ", "Wed, ", "Thu, ", "Fri, ", "Sat, ", "Sun, "];
            const startWeekString = moment().startOf('isoweek');
            const endWeekString = moment().endOf('isoweek');
            startMillis = startWeekString.format("x");
            endMillis = endWeekString.format("x");
        } else if (period === "month") {
            console.log("month");
        } else if (period === "year") {
            console.log("year");
        }

        const query = `SELECT start, end, task_type_id, phase_id FROM tasks WHERE start > ${startMillis} AND end < ${endMillis} and user_id = "${myId}"`;

        let res = await post( query );

        res = res.reduce((acc, item) => {

            let startDay = moment(item["start"], "x");
            startDay = startDay.format("e");
            const minutes = (parseInt(item["end"]) - parseInt(item["start"])) / 60000;

            if (acc.hasOwnProperty(startDay)) {
                if (acc[startDay].hasOwnProperty(item["phase_id"])) {
                    acc[startDay][item["phase_id"]] += minutes;
                } else {
                    acc[startDay][item["phase_id"]] = minutes;
                }
            } else {
                acc[startDay] = { [`${item["phase_id"]}`]: minutes};
            }

            return acc;
        }, {});
        

        let phases = [];
        let nDias = Object.keys(res).length; // NUMERO DE DIAS
        for (let key in res) {
            for (let key2 in res[key]) {
                phases.push(key2);
            }
        }

        phases = new Set(phases);

        let object = {};
        Array.from(phases).forEach((e)=>{ object[e] = Array(nDias).fill(0); });

        for (let key in res){
            for(let key2 in res[key]) {
                object[key2][key-1] = res[key][key2];
            }
        }

        let dtst = [];
        for(let key in object) {
            dtst.push( { label: phaseObj[key], backgroundColor: key === "663" ? "rgba(0,0,0,0.65)" : getColor(), stack: "0", data: object[key] } );
        };

        return {labels: labels, datasets: dtst};

    };

    const getTasks = async () => {

        let date = new Date();
        let today = new Date(date.toDateString());
        let tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        
        let res = await post(
            `SELECT * FROM tasks WHERE user_id = ${myId} AND start > ${today.getTime()} AND end < ${tomorrow.getTime()};`
        );
        
        res.map((e) => {
            e["totalMillis"] = parseInt(e.end) - parseInt(e.start)
            e["totalTime"] = msToTime(e.totalMillis)
            e.start = longMsToTime(e.start);
            e.end = longMsToTime(e.end);
            return e;
        });
        
        tasks = res;
        const data = await getTasksToReport(chartType);
        
        chart.config.data.datasets = data.datasets;
        chart.config.data.labels = data.labels;
        chart.update();
    }

    /* // ¿?
        const changeCardMode = (newMode) => {
            currentTool = "";
            remoteFilePrev = "";
            cardMode = newMode;
            if (cardMode !== "profile") {
                currentTool =
                    cardMode === "clockify" ? CLOCKIFY_WEB : FACTORIAL_WEB;
            }
        };
    */

    $: phases = projectsAndPhases
        .filter((e) => {
            return e["project_id"] === selectedProject["value"];
        })
        .map((e) => {
            return { label: e["phase"], value: e["phase_id"] };
        });
    
    $: taskTypes = selectedPhase.value === "663" ? 
            taskTypesBBDD.filter((e) => e.id === "118" || e.id === "119").map((e) => { return { label: e.name, value: e.id } }) 
        :         
            taskTypesBBDD.filter((e) => e.id !== "118" && e.id !== "119").map((e) => { return { label: e.name, value: e.id } });
    
    $: totalBillable = tasks.reduce((acum, item) => {
        item.task_type_id !== "118" && item.task_type_id !== "119" ? acum.totalMillis += item.totalMillis : "";
        return acum;
    }, {"task_type_id": "", "totalMillis": 0});

    $: totalNoBillable = tasks.reduce((acum, item) => {
        item.task_type_id === "118" || item.task_type_id === "119" ? acum.totalMillis += item.totalMillis : "";
        return acum;
    }, {"task_type_id": "", "totalMillis": 0});


    onMount(async () => {
        await getProjectsAndPhases();
        await getTaskTypes();
        await getAbsenceTypes();
        await getAbsences();
        //await getNonWorkingDays();

        Chart.defaults.global.legend.labels.usePointStyle = true;
        const bars_chart = document.getElementById("bars_chart");

        const config = {
            type: "bar",
            data: {labels: [], datasets: []},
            options: {
                title: { display: false },
                responsive: true,
                legend: { 
                    //display: false,
                    reverse: true,
                    position: "bottom"
                },
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                        beginAtZero: true,
                    },
                }
            },
        }
        chart = new Chart(bars_chart, config);

        await getTasks();
    });

</script>

<svelte:head>
    <title>SkyLab - Factorial</title>
</svelte:head>
<div class="dialogContent">
<!--
    <MenuMyProfile
        onClickProfile={() => changeCardMode("profile")}
        onClickClockify={() => changeCardMode("clockify")}
        onClickFactorial={() => changeCardMode("factorial")}
        onClickDocuments={() => changeCardMode("documents")}
    />
-->

    <!-- <Menu active={PAGE} isDashboard={false} /> -->


    {#if showPopup}
        <div class="alertDiv">
            <Popup
                popupType = "alert"
                popupText = "Invalid data."
                on:dispatchedClick={clickedPopup}
            />
        </div>
    {/if}

    <div class="clocky_input_container">
        <div class="clocky_input_div clocky_task">
            <div class="task_input task_project">
                <img src="/images/factory.svg" class="icon" alt="" />
                <div class="combobox-container">
                    <Combobox
                        options={projects}
                        bind:selectedValue={selectedProject}
                        preSelectedOption=true
                        placeholder="Project..."
                        width="100%"
                    />
                </div>
            </div>
            <div class="task_input task_task">
                <img src="/images/clipboard.svg" class="icon" alt="" />
                <div class="combobox-container">
                    <Combobox
                        options={phases}
                        bind:selectedValue={selectedPhase}
                        preSelectedOption=true
                        placeholder="Phase..."
                        width="100%"
                    />
                </div>
            </div>
            <div class="task_input task_task">
                <img src="/images/clipboard.svg" class="icon" alt="" />
                <div class="combobox-container">
                    <Combobox
                        options={taskTypes}
                        bind:selectedValue={selectedTaskType}
                        preSelectedOption=true
                        placeholder="Task type..."
                        width="100%"
                    />
                </div>
            </div>
            <div class="task_input task_description">
                <img src="/images/task_desc.svg" class="icon" alt="" />
            
                <div class="combobox-container">
                    <TextEdit
                        placeholder="Description..."
                        maxlength="200"
                        bind:value={taskDescription}
                        bgColor="white"
                    />
                </div>

            </div>
        <!--
            <div class="euros">
                <img src="/images/euro_azul.svg" class="icon" alt="" />
                <img src="/images/euro_morado.svg" class="icon" alt="" />
            </div> 
        -->
        </div>
        <div class="clocky_input_div clocky_time">
            <img src="/images/chrono.svg" class="icon" alt="" />
            <div class="time_input time_from"> 
                <TextEdit
                    placeholder="Start..."
                    maxlength="20"
                    bind:value={taskStart}
                    bgColor="white"
                    type="hours"
                />
            </div>
            <span style="padding: 0 10px;"> to </span>
            <div class="time_input time_to">
                <TextEdit
                    placeholder="End..."
                    maxlength="20"
                    bind:value={taskEnd}
                    bgColor="white"
                    type="hours"
                />
            </div>
        </div>

        <button
            class="clocky_input_div clocky_add"
            on:click={addTask(
                taskDescription,
                selectedPhase["value"],
                selectedTaskType["value"],
                taskStart,
                taskEnd
            )}
        >
            <img src="/images/plus_white.svg" alt="" />
        </button>
    </div>

    <div class="time_registry">
        <div class="title">
            <span class="day">{today}</span>
            <div class="predefined_task_buttons">
                <button on:click={() => addTask("Lunch time", 663, 119, "14:00", "14:30")}>Lunch</button> <!-- TODO: mejorar -->
                <button on:click={() => addTask("Round off", 663, 118, "14:30", "14:45")}>Round-off</button>
            </div>
        </div>

        <div class="tasks_container">
            <div class="tasks_detailed">
                {#each tasks as task}
                    <TaskItem
                        id={task.id}
                        taskDescription={task.description}
                        taskProject={ projectObj[task.phase_id] }
                        taskPhase={ phaseObj[task.phase_id] }
                        taskTask={ taskTypeObj[task.task_type_id] }
                        timeStart={task.start}
                        timeEnd={task.end}
                        bind:timeTotal={task.totalTime}
                        on:dispatchModify={modifyTask}
                        on:dispatchCopy={copyTask}
                        on:dispatchDelete={deleteTask}
                    />
                    <hr>
                {/each}
            </div>
            <div class="time_result">
                <span class="billable"> { msToTime(totalBillable.totalMillis) }h </span>
                <span class="no_billable"> { msToTime(totalNoBillable.totalMillis) }h </span>
            </div>
        </div>
    </div>

    <div class="time_report">
        <div class="time_report_chart">
            <div class="chart_menu">
                <div class="menu_left">
                    <!--
                    <button on:click={ () => /*getTasksToReport("Day")*/ }> Day </button>
                    <button on:click={ () => /*getTasksToReport("Week")*/ }> Week </button>
                    <button on:click={ () => /*getTasksToReport("Month")*/ }> Month </button>
                    <button on:click={ () => /*getTasksToReport("Year")*/ }> Year </button>
                    -->
                </div>
                <div class="menu_right">
                    <img src="/images/left-arrow.svg" alt="left arrow" style="margin: 0 5px 0 5px;"/>
                    <img src="/images/right-arrow.svg" alt="right arrow" style="margin: 0 5px 0 5px;"/>
                    <div class="combobox-container">
                        <Combobox
                            options={[]}
                            placeholder=""
                        />
                    </div>
                </div>
            </div>
            <div class="bars_chart_container">
                <canvas width="760" height="390" id="bars_chart" />
            </div>
        </div>

        <div class="absences">
            <div class="total_time">

                <div class="time_div"> <!-- Añadir hover con tiempo bolsa + tiempo vacas | ¿qué pasa si debe tiempo de bolsa, pero tiene vacaciones? -->
                    <span class="time_title">Total time</span>
                    <span class="time_number">{total_time}</span>
                </div>
                <div class="time_div">
                    <span class="time_title">Available time</span>
                    <span class="time_number">{Number(((available_time / 60) / 8).toFixed(3))}</span>
                </div>
                <div class="time_div">
                    <span class="time_title">Accepted time</span>
                    <span class="time_number">{Number(((accepted_time / 60) / 8).toFixed(3))}</span>
                </div>
                <div class="time_div">
                    <span class="time_title">Used time</span>
                    <span class="time_number">{Number(((used_time / 60) / 8).toFixed(3))}</span>
                </div>
                <div class="time_div">
                    <span class="time_title">Pending time</span>
                    <span class="time_number">{Number(((requested_time / 60) / 8).toFixed(3))}</span>
                </div>
                <!--
                <div class="circular_chart"><canvas width="200" height="100" id="total_time_chart"></canvas></div>
                <div class="circular_chart"><canvas width="200" height="100" id="used_time_chart"></canvas></div>
                <div class="circular_chart"><canvas width="200" height="100" id="available_time_chart"></canvas></div>
                <div class="circular_chart"><canvas width="200" height="100" id="requested_time_chart"></canvas></div>
                -->
            </div>
            <div class="absences_form">
                <span>Request absence</span>
                <div>
                    <span>Date</span>
                    <div class="calendarsContainer">
                        <div>
                            <button on:click={ () => {requestAbsenceType = "day"; absenceEnd = ""; half = 0; absenceHourStart = "", absenceHourEnd = "";} }>Day</button>
                            <button on:click={ () => {requestAbsenceType = "days"; absenceEnd = moment().format("DD/MM/YYYY"); half = 0; absenceHourStart = "", absenceHourEnd = "";} }>Days</button>
                            <button on:click={ () => {requestAbsenceType = "half"; absenceEnd = ""; half = 0; absenceHourStart = "", absenceHourEnd = "";} }>Half a day</button>
                            <button on:click={ () => {requestAbsenceType = "hours"; absenceEnd = ""; half = 0; absenceHourStart = "", absenceHourEnd = "";} }>Hours</button>
                        </div>
                        <div>
                            <div class="divComboBoxElement">
                                <DialogSpanCalendarPickerEvent
                                    bind:text={absenceStart}
                                    calendarOptions={[]}
                                    action="edit"
                                    error={false}
                                    height="40px"
                                    width="150px"
                                    marginBottom="0"
                                />
                            </div>
                            {#if requestAbsenceType === "half"}
                                <div class="halfContainer">
                                    <label>
                                        First half
                                        <input type="radio" bind:group={half} value={1}>
                                    </label>
                                    <label>
                                        Second half
                                        <input type="radio" bind:group={half} value={2}>
                                    </label>
                                </div>
                            {:else if requestAbsenceType === "days"}
                                <div class="divComboBoxElement">
                                    <DialogSpanCalendarPickerEvent
                                        bind:text={absenceEnd}
                                        calendarOptions={[]}
                                        action="edit"
                                        error={false}
                                        height="40px"
                                        width="150px"
                                        marginBottom="0"
                                    />
                                </div>
                            {:else if requestAbsenceType === "hours"}
                                <div class="absence_input_div absence_time">
                                    <div class="time_input time_from"> 
                                        <TextEdit
                                            placeholder="Start..."
                                            maxlength="20"
                                            bind:value={absenceHourStart}
                                            bgColor="white"
                                            type="hours"
                                        />
                                    </div>
                                    <span style="padding: 0 10px;"> to </span>
                                    <div class="time_input time_to">
                                        <TextEdit
                                            placeholder="End..."
                                            maxlength="20"
                                            bind:value={absenceHourEnd}
                                            bgColor="white"
                                            type="hours"
                                        />
                                    </div>
                                </div>
                            {:else if requestAbsenceType === "day"}
                                <span style="display: none"></span>
                            {/if}
                        </div>
                    </div>
                </div>
                <div>
                    <span>Type</span>
                    <div class="combobox-container">
                        <Combobox
                            options={absenceTypes}
                            bind:selectedValue={selectedAbsenceType}
                            placeholder="Absence type..."
                            width="100%"
                        />
                    </div>
                </div>
                <div>
                    <span>Description</span>
                    <TextEdit
                        placeholder="Description..."
                        maxlength="500"
                        bind:value={absenceDescription}
                        bgColor="white"
                    />
                </div>
                <button class="w-100" on:click={() => requestAbsence(absenceStart, absenceEnd, selectedAbsenceType, absenceDescription, half, absenceHourStart, absenceHourEnd)}>Request</button>
            </div>

            <div class="total_absences">
                <div class="pending_absences">
                    <span class="absence_title">Pending absences</span>
                    <div class="absences_container">
                        {#each pendingAbsences as {id, type, start, end}}
                            <span style="text-decoration: underline; text-decoration-color: gray;" >{type}</span><span>: {start} - {end}</span><br>
                        {/each}
                    </div>
                </div>
                <div class="accepted_absences">
                    <span class="absence_title">Accepted absences</span>
                    <div class="absences_container">
                        {#each acceptedAbsences as {id, type, start, end}}
                            <span style="text-decoration: underline; text-decoration-color: gray;" >{type}</span><span>: {start} - {end}</span><br>
                        {/each}
                    </div>
                </div>
                <div class="denied_absences">
                    <span class="absence_title">Denied absences</span>
                    <div class="absences_container">
                        {#each deniedAbsences as {id, type, start, end}}
                            <span style="text-decoration: underline; text-decoration-color: gray;" >{type}</span><span>: {start} - {end}</span><br>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>

    hr {
        width: 100%;
        margin: 0;
        padding: 0;
        border: none;
        border-top: 1px solid #ededed !important;
    }

    .total_absences {
        display: flex;
        flex-direction: column;   
        padding: 10px;
    }
    .total_absences > div {
        flex-grow: 1;
        border-bottom: 1px solid #f1f1f1;
        text-align: center;
        height: 33%;
        overflow: auto;
    }
    .absences_container {
        text-align: start;
    }
    .absences_container span {
        font-size: 12px;
        color: gray;
    }
    .total_absences div span.absence_title {
        font-size: 14px;
        text-align: center;
        color: black;
    }
    .w-100 {
        width: 100% !important;
    }
    .calendarsContainer {
        display: flex;
        flex-direction: column;
        height: 70px;
        justify-content: space-between;
    }

    .calendarsContainer > div button {
        width: 85px !important;
    }

    .calendarsContainer > div {
        height: 30px;
    }
    .calendarsContainer div {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    .calendarsContainer > div > div {
        width: 100px !important;
    }
    .calendarsContainer .halfContainer {
        flex-direction: column;
        font-size: 10px;
    }
    .calendarsContainer > div > div > label {
        display: flex;
        justify-content: space-between;
        text-align: center;
        align-items: center;
        width: 100%;
    }
    .calendarsContainer > div > div > label > * {
        width: auto !important;
    } 
    .time_div {
        width: 170px;
        height: 100px;
        display: flex;
        flex-direction: column;
        text-align: center;
    }
    .time_div > span {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
    }
    .time_title {
        height: 30%
    }
    .time_number {
        font-size: 50px;
        color: #666666;
    }
    .absences {
        padding: 10px;
        display: flex;
        flex-direction: row;
    }
    .total_time, .absences_form {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .absences_form {
        justify-content: space-evenly;
        flex-grow: 1;
        padding: 0 20px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
    }
    div.absences_form > span:nth-child(1) {
        text-align: center;
        font-size: 1.5rem;
    }

    .total_time, .total_absences {
        justify-content: space-between;
    }
    .total_time div {
        flex-grow: 1;
    }
    .billable {
        color: #7cdedc;
    }

    .no_billable {
        color: #474954;
    }

    .menu_right > img {
        width: 20px;
    }

    .menu_left {
        align-items: center;
        display: flex;
        width: 75%;
        height: 100%;
        justify-content: space-evenly;
    }
    .menu_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 25%;
        height: 100%;
    }

    .bars_chart_container {
        /* width: 400px !important; */
        padding: 20px;
    }

    .predefined_task_buttons {
        display: flex;
        width: 15%;
        flex-direction: row;
        justify-content: space-between;
    }
    .predefined_task_buttons button, .absences_form button, .chart_menu button {
        width: 100px;
        margin: 0;
		border-radius: 10px;
		background-color: #d7e1ea;
		border: none;
        cursor: pointer;
        color: #6a6a6a;
    }

    .chart_menu {
        padding: 20px;
        width: 100%;
        height: 60px;
        display: flex;
    }

    .time_report_chart, .absences {
        width: 815px;
        height: 490px;
    }

    .combobox-container {
        height: 20px !important;
        width: 100%;
    }

    .day {
        color: #35425b;
        font-size: 1.5rem;
    }

    .title {
        width: 100%;
        height: 55px;
        padding: 20px 30px 0 30px;    
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .tasks_container {
        width: 100%;
        height: 225px;
        display: flex;
        padding: 5px 0;
    }

    .tasks_detailed {
        display: flex;
        flex-direction: column;
        padding: 20px;
        width: 90%;
        overflow: auto;
    }

    .time_result > span {
        font-size: 20px;
    }

    .time_result {
        width: 10%;
        display: flex;
        flex-direction: column;
        /*justify-content: center;*/
        align-items: center;
        padding-top: 46px;
    }

    .icon {
        width: 20px;
        margin: 0 5px 0 5px;
    }

    .time_registry {
        width: 1640px;
        height: 280px;
        margin: 5px 0 5px 0;
    }

    .time_report {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 1640px;
        height: 490px;
        margin: 5px 0 5px 0;
    }

    .clocky_add img {
        width: 35px;
    }

    .task_description {
        flex-grow: 3;
    }

    .time_input,
    .clocky_time span {
        flex-grow: 1;
    }

    .clocky_time span {
        text-align: center;
    }

    .task_project {
        flex-grow: 2;
        /*margin: 0 20px 0 20px;*/
    }

    .task_task {
        flex-grow: 1;
    }

    .clocky_task .task_input {
        align-items: center;
    }

    .task_input {
        display: flex;
        padding: 10px 10px 10px 0;
    }

    div.dialogContent {
        background-color: var(--labit-background-gray);
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 20px;
        flex-direction: column;
    }

    div.clocky_input_container {
        margin-bottom: 15px;
        width: 1640px;
        height: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
    }

    .clocky_input_div,
    .absence_input_div,
    .time_registry,
    .time_report_chart, .absences {
        border-radius: 19px;
        background-color: white;
    }

    div.clocky_task {
        background-color: white;
        padding: 0 20px 0 20px;
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-grow: 6;
        height: 100%;
    }
    div.clocky_time, div.absence_time {
        background-color: white;
        padding: 0 20px 0 20px;
        margin-left: 15px;
        margin-right: 15px;
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        height: 100%;
        width: 150px;
    }
    div.absence_time {
        padding: 0 !important;
        margin-left: 40px !important;
        margin-right: 0 !important;
    }
    .clocky_add {
        background-color: #004979;
        width: 147px !important;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin: 0 !important;
    }

    div.clocky_time div {
        width: 100px;
    }
    div.divComboBoxElement {
        width: 23%;
    }

    :global(div.time_input > input) {
        text-align: center;
    }

    :global(div.task_input > input) {
        padding-left: 10px;
    }
    .alertDiv {
        position: absolute;
        width: 350px;
        height: 200px;
        top: 40%;
        left: 41%;
        border-radius: 10px;
        background-color: #d7e1ea;
        z-index: 1;
        box-shadow: 2px 1px 3px 0px #afafaf;
    }

</style>
